'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pick = {};

exports.__exports = pick;
